import { buildImgSrc } from '@/helpers/image-url'
import { getImageOrigin } from '@/scopes/account/common/utils/getImageOrigin'

const CARD_IMAGE_SIZE = 80
const CARD_PLACEHOLDER_SIZE = 20

interface CardImageProps {
  mediaPlaceholderSrc: string | undefined
  mediaSrc: string
}

export function getCardImageProps(imageSrc: string): CardImageProps {
  if (!imageSrc) {
    return {
      mediaPlaceholderSrc: undefined,
      mediaSrc: '',
    }
  }

  const normalizedImageSrc = imageSrc.split('?')[0]
  const imageOrigin = getImageOrigin(imageSrc)

  return {
    mediaPlaceholderSrc: buildImgSrc(
      normalizedImageSrc,
      CARD_PLACEHOLDER_SIZE,
      CARD_PLACEHOLDER_SIZE,
      imageOrigin,
    ),
    mediaSrc: buildImgSrc(
      normalizedImageSrc,
      CARD_IMAGE_SIZE * 2,
      CARD_IMAGE_SIZE * 2,
      imageOrigin,
    ),
  }
}
